import { render, staticRenderFns } from "./submitPackOrder.vue?vue&type=template&id=ec7eb07a&scoped=true"
import script from "./submitPackOrder.vue?vue&type=script&lang=js"
export * from "./submitPackOrder.vue?vue&type=script&lang=js"
import style0 from "./submitPackOrder.vue?vue&type=style&index=0&id=ec7eb07a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7eb07a",
  null
  
)

export default component.exports